<template>
  <div class="alert-container">
    <v-alert
      :value="visible"
      :type="alert.type"
      transition="scale-transition"
    >
      {{ alert.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ALERT_KEY } from '../store/types/alerts.types'

export default {
  data() {
    return {
      timeout: null,
      visible: false,
    }
  },
  computed: {
    ...mapState({
      alert: state => state.alerts[ALERT_KEY],
    }),
  },
  watch: {
    alert() {
      this.visible = true
      this.timeout = setTimeout(() => {
        this.visible = false
        clearTimeout(this.timeout)
      }, 3500)
    },
  },
}
</script>

<style lang="stylus" scoped>
.alert-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

@media only screen and (max-width: 768px) {
  .alert-container {
    width: 100%;
  }
}
</style>
